import { Label, LabelKey } from "../model/Label.js";

export type MapToggleState = "none" | "map" | "list";

export interface MapToggleOptions {
    state?: MapToggleState;
    urlMap?: string;
    urlList?: string;
    element?: HTMLDivElement;
}

export class MapToggle {
    public readonly element: HTMLDivElement;

    public readonly onToggle = e5.Signal.create<[MapToggleState]>();

    private _state: MapToggleState = "none";
    private _buttons: MapToggleButton[] = [];

    constructor(options: MapToggleOptions = {}) {

        options = e5.ObjectUtil.extend({
            state: "none",
            urlMap: "",
            urlList: ""
        } as MapToggleOptions, options);

        this._state = options.state;

        this.element = options.element || document.createElement("div");
        this.element.classList.add("e5-map-toggle", "e5-base__no-print");
        this.element.innerHTML = `<div class="e5-map-toggle__menu"></div>`;

        this.addButton({
            labelKey: "map.toggle.map",
            state: "map",
            toggle: this,
            active: options.state === "map",
            url: options.urlMap
        });

        this.addButton({
            labelKey: "map.toggle.list",
            state: "list",
            toggle: this,
            active: options.state === "list",
            url: options.urlList
        });
    }

    private addButton(options: MapToggleButtonOptions): MapToggleButton {
        var btn = new MapToggleButton(options);
        this.element.querySelector(".e5-map-toggle__menu").appendChild(btn.element);
        this._buttons.push(btn);
        return btn;
    }

    public get state(): MapToggleState {
        return this._state;
    }

    public set state(value: MapToggleState) {
        if (this._state === value) {
            return;
        }
        this._state = value;

        for (var btn of this._buttons) {
            btn.active = btn.state === value;
        }

        this.onToggle.dispatch(value);
    }
}

export interface MapToggleButtonOptions {
    active?: boolean;
    url?: string;
    labelKey: LabelKey;
    state: MapToggleState;
    toggle: MapToggle;
}

export class MapToggleButton {
    public element: HTMLElement;
    public readonly state: MapToggleState;

    constructor(options: MapToggleButtonOptions) {

        options = e5.ObjectUtil.extend({
            active: false
        } as MapToggleButtonOptions, options);
        this.state = options.state;


        if (options.url) {
            var a = document.createElement("a");
            a.href = options.url;
            this.element = a;
        } else {
            var btn = document.createElement("button");
            this.element = btn;
            btn.addEventListener("click", () => {
                options.toggle.state = this.state;
            });
        }

        this.element.textContent = Label.text(options.labelKey);

        this.element.className = [
            `e5-map-toggle__menu-item`,
            `e5-map-toggle__menu-item--${options.state}`,
            `${options.active ? "e5-map-toggle__menu-item--active" : ""}`
        ].join(" ");
    }

    public get active(): boolean {
        return this.element.classList.contains("e5-map-toggle__menu-item--active");
    }

    public set active(value: boolean) {
        this.element.classList.toggle("e5-map-toggle__menu-item--active", value);
    }
}